import type { State } from '../../state/types.tsx';

export const getIssueBeingEdited = (state: State): string | null =>
	state.domain.issueModal.issueBeingEdited;

export const getIsLoadingIssueDescription = (state: State): boolean =>
	state.domain.issueModal.isLoadingIssueDescription;
